import React, { ReactElement, cloneElement } from "react";
import { useAppSelector } from "../../../lib/redux/hook.ts";
import { PillsColor, PillsSize, colorKey, pillLabelSizeMap, pillSizeMap, pillVariantKey } from "./dto.ts";

interface Props {
    size: PillsSize;
    label: string | string[]
    startIcon?: ReactElement
    endIcon?: ReactElement
    outline: boolean
    emphasis: boolean
    color: PillsColor
    darker?: boolean
    onClick?: () => void
}

export function Pills(props: Props) {
    const layoutState = useAppSelector(state => state.layout)
    
    return (
        <div
            style={{
                ...pillSizeMap.get(props.size),
                ...colorKey(props.color, layoutState.theme).pillContainerVariant.get(pillVariantKey(props.emphasis, props.outline, props.darker)),
                ...{ display: "flex", justifyContent: 'center', alignItems: 'center', gap: 4, borderWidth: '1px', borderStyle: 'solid', width: 'max-content' },
            }}
        >
            {
                props.startIcon && cloneElement(props.startIcon, { color: colorKey(props.color, layoutState.theme).contentColor.get(pillVariantKey(props.emphasis, props.outline)) })
            }
            <span
                style={{
                    ...pillLabelSizeMap.get(props.size),
                    ...{ color: colorKey(props.color, layoutState.theme).contentColor.get(pillVariantKey(props.emphasis, props.outline)) }
                }}
            >
                {props.label}
            </span>
            {
                props.endIcon && cloneElement(props.endIcon, { color: colorKey(props.color, layoutState.theme).contentColor.get(pillVariantKey(props.emphasis, props.outline)) })
            }
        </div>
    )
}